// extracted by mini-css-extract-plugin
export default {"custom-dropdown":"index_custom-dropdown__-Tlsm","hide-dropdown-arrow":"index_hide-dropdown-arrow__58SOv","ant-dropdown-trigger":"index_ant-dropdown-trigger__ckKEg"};